import { ListItem } from '@cubeyou-team/hx-react-components';
import React, { FC, useCallback, useState } from 'react';

import translations from 'src/lang';

import { MoreActions } from '../../../../../../../more-actions';
import { useStanleyQueryPanel } from '../../../../../../../../providers/StanleyQueryPanelContext';
import {
  StanleyQueryHistoryItemDeleteModal,
  StanleyQueryHistoryItemRenameModal,
} from './components';

const tHistoryActions =
  translations['en-US'].STANLEY_QUERY.MODAL.HISTORY.MORE_ACTIONS;

interface StanleyQueryHistoryItemMoreActionsProps {
  runId: string;
  title: string;
  onMenuOpenChange?: (isOpen: boolean) => void;
}

export const StanleyQueryHistoryItemMoreActions: FC<
  StanleyQueryHistoryItemMoreActionsProps
> = ({ runId, title, onMenuOpenChange }) => {
  const { handleEditHistoryItem } = useStanleyQueryPanel();
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false);
  const [isRenameModalOpen, setIsRenameModalOpen] = useState<boolean>(false);

  const handleOpenDeleteModal = useCallback(
    () => setIsDeleteModalOpen(true),
    []
  );

  const handleCloseDeleteModal = useCallback(
    () => setIsDeleteModalOpen(false),
    []
  );

  const handleOpenRenameModal = useCallback(
    () => setIsRenameModalOpen(true),
    []
  );

  const handleCloseRenameModal = useCallback(
    () => setIsRenameModalOpen(false),
    []
  );

  return (
    <>
      <MoreActions
        variant="dark"
        onOpenChange={onMenuOpenChange}
        items={(closeDropdown) => [
          <ListItem
            key="rename"
            text={tHistoryActions.RENAME}
            iconLeft="icon-text"
            onClick={() => {
              closeDropdown();
              window.setTimeout(handleOpenRenameModal, 0);
            }}
          />,
          <ListItem
            key="edit"
            text={tHistoryActions.EDIT}
            iconLeft="icon-edit"
            onClick={() => {
              closeDropdown();
              handleEditHistoryItem(runId);
            }}
          />,
          <ListItem
            key="delete"
            text={tHistoryActions.DELETE}
            iconLeft="icon-delete"
            onClick={() => {
              closeDropdown();
              window.setTimeout(handleOpenDeleteModal, 0);
            }}
          />,
        ]}
      />
      <StanleyQueryHistoryItemDeleteModal
        isOpen={isDeleteModalOpen}
        runId={runId}
        title={title}
        onClose={handleCloseDeleteModal}
      />
      <StanleyQueryHistoryItemRenameModal
        isOpen={isRenameModalOpen}
        runId={runId}
        title={title}
        onClose={handleCloseRenameModal}
      />
    </>
  );
};
